import * as React from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Input, Spinner } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { selectUser, UserRoleEnum } from '../../redux/UserSlice';
import { ReportGroupMapping, selectReportGroup, setReportGroup } from '../../redux/ReportSlice';
import utilityHelper from '../../utils/utilityHelper';



const ReportNavigator = (props: any) => {
    const history = useHistory();
    const user = useAppSelector(selectUser);
    const reportGroup = useAppSelector(selectReportGroup);
    const dispatch = useAppDispatch();

    const [isPublic, setIsPublic] = useState<boolean>(props.publicreports);

    const isAdminUser = function () : boolean {
        var isAdmin: boolean = false;
        if (user && user.userProfile && user.userProfile.role && user.userProfile.role === UserRoleEnum.Admin) {
            isAdmin = true;
        }
        return isAdmin;
    }
    const getReportGroupItems = function(isAdmin : boolean): Array<{ label: string, value: string }> {
        var result: Array<{ label: string, value: string }> = [];
        var exclusion: string = "ALL"; 
        if (!isAdmin) {
            exclusion += ",GENERALADMIN";
        }
        Object.keys(ReportGroupMapping).map(k => exclusion.indexOf(k) >= 0 ? "" : result.push({ label: ReportGroupMapping[k], value: k}))
        return [{ label: "All Groups", value: "ALL" }].concat(result.sort((a: { label: string, value: string }, b: { label: string, value: string }) => a.label.localeCompare(b.label)));
    }
    //TODO change data binding to use entities slice
    const onChangeValue = (event: any) => {
        dispatch(setReportGroup(event.target.value));
    }


    React.useEffect(() => {

        if (props.publicreports) {
            setIsPublic(props.publicreports);
        }

    }, [props])

    return (
        <React.Fragment>
            <div>
                <ul>
                    {getReportGroupItems(isAdminUser()).map((item) => (
                        <li key={item.value}>
                            <Input type="radio"
                                value={item.value}
                                name="rgchooser"
                                onChange={onChangeValue}
                                checked={item.value === reportGroup}
                            />
                            {item.label}

                        </li>
                    ))}
                </ul>
            </div>

        </React.Fragment>
    )
}

ReportNavigator.defaultProps = {
    publicreports: false,
};

export default ReportNavigator;